import { React, useEffect, useState, useRef } from "react";
import "../../styles/desktop/eventos.css";
import getRegistrosEventos from "../../API/events/getRegistrosEventos";

const Eventos = () => {
  const [eventos, setEventos] = useState([]);
  const [filteredEventos, setFilteredEventos] = useState([]);
  const [loading, setLoading] = useState(true);
  const [filtroTipo, setFiltroTipo] = useState("Todos");
  const [filtroDataInicio, setFiltroDataInicio] = useState("");
  const [filtroDataFim, setFiltroDataFim] = useState("");
  const [filtroNome, setFiltroNome] = useState("");
  const [filtroIP, setFiltroIP] = useState("");
  const [filtroStatusAlarme, setFiltroStatusAlarme] = useState("Todos");
  const intervalRef = useRef(null);

  const getData = async () => {
    setLoading(true);
    const data = await getRegistrosEventos();
    
    const sortedData = data.sort((a, b) => {
      const [diaA, mesA, anoA] = a.data.split("/");
      const [diaB, mesB, anoB] = b.data.split("/");
      const dateA = new Date(`${anoA}-${mesA}-${diaA}`);
      const dateB = new Date(`${anoB}-${mesB}-${diaB}`);
      
      return dateB - dateA;
    });
  
    setEventos(sortedData);
    setFilteredEventos(sortedData);
    setLoading(false);
  };

  useEffect(() => {
    const isDefaultFilters =
      filtroTipo === "Todos" &&
      !filtroDataInicio &&
      !filtroDataFim &&
      !filtroNome &&
      !filtroIP &&
      filtroStatusAlarme === "Todos";

    if (intervalRef.current) {
      clearInterval(intervalRef.current);
    }

    if (isDefaultFilters) {
      intervalRef.current = setInterval(getData, 100000);
    }

    return () => clearInterval(intervalRef.current);
  }, [
    filtroTipo,
    filtroDataInicio,
    filtroDataFim,
    filtroNome,
    filtroIP,
    filtroStatusAlarme,
  ]);

  useEffect(() => {
    getData();
  }, []);

  const handleFilter = () => {
    if (intervalRef.current) {
      clearInterval(intervalRef.current);
      intervalRef.current = null;
    }
  
    const filtered = eventos.filter((evento) => {
      const [dia, mes, ano] = evento.data.split("/");
      const eventoData = new Date(`${ano}-${mes}-${dia}`);
      
      const dataInicioMatches = filtroDataInicio
        ? eventoData >= new Date(filtroDataInicio)
        : true;
      const dataFimMatches = filtroDataFim
        ? eventoData <= new Date(filtroDataFim)
        : true;
  
      const tipoMatches =
        filtroTipo === "Todos" ||
        (filtroTipo === "Dispositivos" && ["Dispositivo", "Facial", "Camera"].includes(evento.tipo)) ||
        (filtroTipo === "Agendamentos" && ["Agendamentos","Iluminação", "exaustor"].includes(evento.tipo)) ||
        (filtroTipo === "Notificações" && ["Notificações","DVR", "Camera IA", "NVR"].includes(evento.tipo)) ||
        evento.tipo === filtroTipo;
  
      const nomeMatches = filtroNome
        ? evento.nome.toLowerCase().includes(filtroNome.toLowerCase())
        : true;
      const ipMatches = filtroIP ? evento.ip.includes(filtroIP) : true;
      const statusAlarmeMatches =
        filtroStatusAlarme === "Todos" ||
        (filtroStatusAlarme === "Ativo" && evento.status === "true") ||
        (filtroStatusAlarme === "Inativo" && evento.status === "false");
  
      return (
        tipoMatches &&
        dataInicioMatches &&
        dataFimMatches &&
        nomeMatches &&
        ipMatches &&
        statusAlarmeMatches
      );
    });
    setFilteredEventos(filtered);
  };

  const handleClearFilters = () => {
    setFiltroTipo("Todos");
    setFiltroDataInicio("");
    setFiltroDataFim("");
    setFiltroNome("");
    setFiltroIP("");
    setFiltroStatusAlarme("Todos");
    setFilteredEventos(eventos);
  };
  
  return (
    <div className="ContainerHistory">
      <h1 className="tituloHistory">Registros de eventos</h1>
      <div className="ContainerFiltro">
        <div className="filterRow">
          <div className="filterGroup">
            <label htmlFor="filtroTipo">Tipo:</label>
            <select
              id="filtroTipo"
              name="filtroTipo"
              value={filtroTipo}
              onChange={(e) => setFiltroTipo(e.target.value)}
            >
              <option value="Todos">Todos</option>
              <option value="Dispositivos">Dispositivos</option>
              <option value="Agendamentos">Agendamentos</option>
              <option value="Alarme">Alarmes</option>
              <option value="Notificações">Notificações</option>
            </select>
          </div>

          <div className="filterGroup">
            <label htmlFor="filtroDataInicio">Data de início:</label>
            <input
              type="date"
              id="filtroDataInicio"
              name="filtroDataInicio"
              value={filtroDataInicio}
              onChange={(e) => setFiltroDataInicio(e.target.value)}
            />
          </div>

          <div className="filterGroup">
            <label htmlFor="filtroDataFim">Data de fim:</label>
            <input
              type="date"
              id="filtroDataFim"
              name="filtroDataFim"
              value={filtroDataFim}
              onChange={(e) => setFiltroDataFim(e.target.value)}
            />
          </div>
        </div>

        <div className="filterRow">
          <div className="filterGroup">
            <label htmlFor="filtroNome">Nome do Dispositivo:</label>
            <input
              type="text"
              id="filtroNome"
              name="filtroNome"
              value={filtroNome}
              onChange={(e) => setFiltroNome(e.target.value)}
            />
          </div>

          <div className="filterGroup">
            <label htmlFor="filtroIP">IP do Dispositivo:</label>
            <input
              type="text"
              id="filtroIP"
              name="filtroIP"
              value={filtroIP}
              onChange={(e) => setFiltroIP(e.target.value)}
            />
          </div>

          <div className="filterGroup">
            <label htmlFor="filtroStatusAlarme">Status do evento:</label>
            <select
              id="filtroStatusAlarme"
              name="filtroStatusAlarme"
              value={filtroStatusAlarme}
              onChange={(e) => setFiltroStatusAlarme(e.target.value)}
            >
              <option value="Todos">Todos</option>
              <option value="Ativo">Ativo</option>
              <option value="Inativo">Inativo</option>
            </select>
          </div>
        </div>

        <div className="buttonRow">
          <button className="btnFiltrar" onClick={handleFilter}>Filtrar</button>
          <button className="btnFiltrar" onClick={handleClearFilters}>Limpar</button>
        </div>
      </div>

      <div className={`ContainerTabela ${loading ? "shimmer" : ""}`}>
        {!loading && filteredEventos.length === 0 ? (
          <p className="noRecordsMessage">Nenhum registro foi encontrado</p>
        ) : (
          !loading && (
            <table>
              <thead>
                <tr>
                  <th>Nome</th>
                  <th>Tipo</th>
                  <th>Descrição</th>
                  <th>IP Controlador</th>
                  <th>Data</th>
                  <th>Hora</th>
                </tr>
              </thead>
              <tbody>
                {filteredEventos.map((evento, index) => (
                  <tr
                    key={index}
                    className={
                      evento.tipo === "Alarme" && evento.status === 'false'
                        ? "alarme-false"
                        : ""
                    }
                  >
                    <td>{evento.nome}</td>
                    <td>{evento.tipo}</td>
                    <td>{evento.descricao}</td>
                    <td>{evento.ip}</td>
                    <td>{evento.data}</td>
                    <td>{evento.hora}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          )
        )}
      </div>
    </div>
  );
};

export default Eventos;
